import React, { CSSProperties } from 'react'
import className from 'classnames/bind'

import style from './MyhouseCommonButton.module.scss'

import ArrowRight7x18 from '@Ui/images/myhouse/myhouse_main_landPrice--more.svg'

const cx = className.bind(style)

export enum BUTTONTYPE {
  DEFAULT = 'default',
  LINK_GRAY = 'link_gray',
  LINK_GREEN = 'link_green',
  LINK_WHITE = 'link_white',
  LINK_DARK_GRAY = 'link_dark_gray',
}

type Props = {
  style?: CSSProperties
  buttonText: string
  buttonType?: BUTTONTYPE
  icon?: boolean
  onClick?: (e: React.SyntheticEvent) => void
  isFloating?: boolean
  className?: string
}

const MyhouseCommonButton: React.FC<Props> = ({ style, buttonText, buttonType, icon, onClick, isFloating, className }: Props) => {
  return (
    <div className={cx('article', isFloating && 'type_floating', className)} style={style}>
      {/* default : #4080f7, link_gray : #f4f6f9, link_green : #edfaf3 */}
      <a href="#" className={cx('link', buttonType)} onClick={onClick}>
        {buttonText}
        {/* todo: 이미지 문의 후 작업 */}
        {icon && (
          <span className={cx('icon')}>
            <ArrowRight7x18 />
          </span>
        )}
      </a>
    </div>
  )
}

export default MyhouseCommonButton
